module.exports = __webpack_public_path__ + "img/place2.8594be63.jpg";